import { connect } from 'react-redux';
import { saveRecentSearch } from 'actions/search-actions';
import PlayControl from './PlayControl';

const mapDispatchToProps = {
  saveRecentSearch,
};

export default connect(null, mapDispatchToProps)(PlayControl);
